import { render, staticRenderFns } from "./ServeManage.vue?vue&type=template&id=c3e2dc42&scoped=true&"
import script from "./ServeManage.vue?vue&type=script&lang=js&"
export * from "./ServeManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e2dc42",
  null
  
)

export default component.exports